export enum PriceType {
  one_time = 'one_time',
  recurring = 'recurring',
}
